module.exports = {"fr-FR":{"table-header":{"actions":"Actions"}}}